<template>
    <regular-input 
      :value="input"
      @input="input = $event"
      type="text" :placeholder="criteria" class=""/>
</template>

<script>
import regularInput from '../regularInput.vue'

export default {
  name: 'filter',
  components: {
    regularInput
  },
  props: {
    array: {
      type: Array,
      required: false
    },
    criteria: {
      type: String,
      required: false
    },
    reverse: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      input: '',
      searched: []
    }
  },
  methods: {
    match: function (regex) {
      regex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
      let re = new RegExp('^' + regex, 'i')
      return function (element) {
        return re.test(element)
      }
    },
    search: function (value) {
      if (value !== '') {
        const matcher = this.match(value)
        this.searched = this.array.filter(x => matcher(x[this.criteria]))
      } else {
        this.searched = this.array
      }
    }
  },
  mounted: function () {
    this.searched = this.array
    if (this.reverse) {
      var reverse = JSON.parse(JSON.stringify(this.searched))
      this.$emit('input', reverse.reverse())
    } else this.$emit('input', this.searched)
  },
  watch: {
    input: function (val) {
      if (this.criteria !== '') {
        this.search(val)
        if (this.reverse) {
          var reverse = JSON.parse(JSON.stringify(this.searched))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.searched)
      }
    },
    criteria: function (val) {
      if (this.input !== '') {
        this.search(this.input)
        if (this.reverse) {
          var reverse = JSON.parse(JSON.stringify(this.searched))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.searched)
      }
    },
    array: function () {
      if (this.input !== '' && this.criteria !== '') {
        this.search(this.input)
        if (this.reverse) {
          let reverse = JSON.parse(JSON.stringify(this.searched))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.searched)
      } else {
        if (this.reverse) {
          let reverse = JSON.parse(JSON.stringify(this.array))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.array)
      }
    }
  }
}
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// regularFilter.vue?2075963e